import axiosPost from "../../axiosPost";
import { respuestaDe } from "../../respuesta";

export const RNHHorarioRangoIns = async (credentials, data) => {
  const body = {
    service: "RNHHorarioRangoIns",
    params: {
      rnhHorarioRangoHorarioId: data?.horarioId || null,
      rnhHorarioRangoCod: data?.cod || null,
      rnhHorarioRangoNombre: data?.nombre || null,
      rnhHorarioRangoEntrada: data?.entrada || null,
      rnhHorarioRangoSalida: data?.salida || null,

      rnhHorarioRangoDomingo: data?.domingo ?? "N",
      rnhHorarioRangoLunes: data?.lunes ?? "N",
      rnhHorarioRangoMartes: data?.martes ?? "N",
      rnhHorarioRangoMiercoles: data?.miercoles ?? "N",
      rnhHorarioRangoJueves: data?.jueves ?? "N",
      rnhHorarioRangoViernes: data?.viernes ?? "N",
      rnhHorarioRangoSabado: data?.sabado ?? "N",
    },
  };
  return respuestaDe(await axiosPost(body, credentials));
};
